import { SESSION_TIMEOUT, REFRESH_SESSION_THRESHOLD } from '@dynameat/constants/settings';

export class SessionController {
  static get storage() {
    return localStorage;
  }

  static setupSession(token, subdomain, others = {}) {
    if (!token) throw new Error('Token is mandatory to setup session');
    if (!subdomain) throw new Error('Subdomain is mandatory to setup session');
    const data = {
      ...others, token, subdomain: subdomain.toLowerCase(), timestamp: new Date().getTime()
    };
    Object.entries(data).forEach(([key, value]) => {
      SessionController.storage.setItem(key, value);
    });
  }

  static clearSession() {
    SessionController.storage.clear();
  }

  static get subdomain() {
    return SessionController.storage.getItem('subdomain');
  }

  static get token() {
    return SessionController.storage.getItem('token') || '';
  }

  static set token(newToken) {
    SessionController.storage.setItem('token', newToken);
  }

  static set timestamp(newTimeStamp) {
    SessionController.storage.setItem('timestamp', newTimeStamp);
  }

  static needRefreshSession() {
    const timestamp = SessionController.storage.getItem('timestamp');
    if (!timestamp) return true; // Sanity check for timestamp not existing
    const now = new Date().getTime();
    return (now - timestamp) > REFRESH_SESSION_THRESHOLD;
  }

  static isValidSession() {
    const timestamp = SessionController.storage.getItem('timestamp');
    return SessionController.token
      && SessionController.subdomain
      && timestamp
      && (new Date().getTime() - timestamp) < SESSION_TIMEOUT;
  }
}
